import script from "./AnnualFundraisingSummary.vue?vue&type=script&setup=true&lang=js"
export * from "./AnnualFundraisingSummary.vue?vue&type=script&setup=true&lang=js"

import "./AnnualFundraisingSummary.vue?vue&type=style&index=0&id=1313f1f1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1313f1f1"]])

export default __exports__